
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"46","height":"46","fill":"none","xmlns":"http://www.w3.org/2000/svg","transform":"translate(-11 -9)"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_388_671)"}},[_c('path',{attrs:{"d":"M11 21a12 12 0 1024.002 0A12 12 0 0011 21z","fill":"#fff"}}),_c('path',{attrs:{"d":"M11 21a12 12 0 1024.002 0A12 12 0 0011 21z","stroke":"#CFCFCF","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('path',{attrs:{"d":"M17.666 21h10.667","stroke":"#EC6567","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_388_671","x":".5","y":".5","width":"45","height":"45","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"5"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_388_671"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_388_671","result":"shape"}})])])])
          )
        }
      }
    